export default __webpack_public_path__ + "static/media/mp-diamante-oro.cdac908b.svg";